import AdminLayout from '../../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import React, { useState, useEffect } from 'react';

export default function Details() {
  const location = useLocation();
  const { data } = location.state || {};
  const [facultyData, setFacultyData] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  useEffect(() => {
    if (data) {
      fetchFacultyData();
    }
  }, [data]);

  const fetchFacultyData = async () => {
    const token = localStorage.getItem('token');
    try {
      const requestData = JSON.stringify({
        facultyId: data.id,
      });

      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/faculty/getbanck`,
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
        data: requestData,
      };

      const response = await axios.request(config);
      setFacultyData(response.data[0] || null); // Set to null if no data is found
    } catch (err) {
      console.error('Error fetching faculty data:', err);
      err.response?.status === 401 && navigate('/');
    } finally {
      setIsLoading(false); // Set loading to false once data is fetched
    }
  };

  return (
    <AdminLayout ac3="active">
      <main id="main" className="main">
        <div className="pagetitle ">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                <Link to="/ListFaculty">List Faculty</Link>
              </li>
              <li className="breadcrumb-item ">
                <Link to="/ListFaculty">View Faculty</Link>
              </li>
              <li className="breadcrumb-item active">
                View Faculty Bank Details
              </li>
            </ol>
          </nav>
        </div>

        <hr className="mb-0" />
        <section className="section profile mt-3">
          <div className="row">
            <div className="col-xl-4">
              <div className="card">
                <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
                  <img
                    src="assets/img/profile-img.png"
                    alt="Profile"
                    className="rounded-circle"
                  />
                  <h2>{data?.name}</h2>
                  <h3>{data?.contactNo}</h3>
                </div>
              </div>
            </div>

            <div className="col-xl-8">
              <div className="card">
                <div className="card-body p-3 pb-0">
                  <ul className="nav nav-tabs nav-tabs-bordered" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        data-bs-toggle="tab"
                        data-bs-target="#profile-overview"
                        aria-selected="true"
                        role="tab"
                      >
                        Bank Details
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content pt-2">
                    <div
                      className="tab-pane fade show active profile-overview"
                      id="profile-overview"
                      role="tabpanel"
                    >
                      {isLoading ? (
                        <p>Loading bank details...</p>
                      ) : facultyData ? (
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="tab-content pt-2">
                              <div
                                className="tab-pane fade profile-overview active show"
                                id="profile-overview"
                                role="tabpanel"
                              >
                                <div className="row">
                                  <div className="col-lg-4 col-md-4 label ">
                                    Bank Name
                                  </div>
                                  <div className="col-lg-7 col-md-8">
                                    {facultyData.bankName}
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-lg-4 col-md-4 label">
                                    Branch Name
                                  </div>
                                  <div className="col-lg-7 col-md-8">
                                    {facultyData.branchName}
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-lg-4 col-md-4 label">
                                    Account Holder Name
                                  </div>
                                  <div className="col-lg-7 col-md-8">
                                    {facultyData.accountHolderName}
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-lg-4 col-md-4 label">
                                    Bank Account Number
                                  </div>
                                  <div className="col-lg-7 col-md-8">
                                    {facultyData.bankAccountNumber}
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-lg-4 col-md-4 label">
                                    IFSC Code
                                  </div>
                                  <div className="col-lg-7 col-md-8">
                                    {facultyData.ifscCode}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <p>Bank details not found.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </AdminLayout>
  );
}
